import {warningAceptarCancelarConfirming} from "./warning-aceptar-cancelar-confirming";

$(function () {
    if (typeof authUser !== 'undefined') {
        if (authUser.rol_id === 3 || (authUser.rol_id !== 3 && typeof isImpersonating !== 'undefined')) {
            loadPedidosMenu();
            //setInterval(loadPedidosMenu, 15 * 60 * 1000);
        }
    }
});

/*** PEDIDOS ASIGNADOS ***/

window.loadPedidosMenu = function (recalcularAsignados = false) {
    $.ajax({
        url:      urlPedido + '/get-totales',
        type:     'POST',
        data:     {
            update_asignados: recalcularAsignados ? 1 : 0,
        },
        dataType: 'json',
    })
     .done(function (response) {
         fillPedidosMenu(response);
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status === 422) {
             errors = composeValidationError(jqXHR.responseJSON.errors);
         } else if (jqXHR.responseJSON.message) {
             errors = jqXHR.responseJSON.message;
         }
         pNotifyError(errors);
     });
}

window.fillPedidosMenu = function (pedidos) {
    const pedidosAsignado = $('#pedidosAsignadosMenu');
    pedidosAsignado.find('.item-number').text(pedidos.cantidad);
    pedidosAsignado.find('.item-quantity').text(number_format(pedidos.total) + ' €');
    if (pedidos.envio) {
        pedidosAsignado.find('.item-number').addClass('bg-success');
    }
    const pedidosPreparados                  = $('#pedidosPreparadosMenu');
    const horaActual                         = new Date();
    const [horaCorteHoras, horaCorteMinutos] = pedidos.hora_corte.split(':').map(Number);
    const horaCorte                          = new Date();
    horaCorte.setHours(horaCorteHoras, horaCorteMinutos, 0, 0);

    if (pedidos.envio && horaActual <= horaCorte) {
        let spanTitle    = pedidosPreparados.find('span').attr('data-bs-title');
        let newSpanTitle = spanTitle.replace(':hour', pedidos.hora_corte);

        // Obtenemos la instancia del tooltip y actualizamos el título
        let tooltipInstance           = bootstrap.Tooltip.getInstance(pedidosPreparados.find('span')[0]);
        tooltipInstance._config.title = newSpanTitle;
        tooltipInstance.setContent();
        tooltipInstance.update();

        pedidosPreparados.show();
    } else {
        pedidosPreparados.hide();
    }

    if (formaPago === 'WEB TARJETA') {
        const menuTopUsuaurio = $('#menuTopDropdownUsuario');
        menuTopUsuaurio.find('.item-balance').text(`(${number_format(pedidos.saldo_contable)}€)`);
    }
}

/*** /PEDIDOS ASIGNADOS ***/

/*** PEDIDO EN UN CLICK ***/

window.storeQuickOrder = function (articulo_id, codigo, cantidad) {
    if ($('#btn-1-click-loading' + codigo).is(':hidden')) {
        $('#btn-1-click' + codigo).hide();
        $('#btn-1-click-loading' + codigo).show();

        if (cantidad === 0) {
            $(`#product-id-${articulo_id} .product-quantity input`).val(1);
            cantidad = 1;
        }

        $.ajax({
            url:      urlPedido + '/store-quick-order',
            type:     'POST',
            data:     {
                articulos: [
                    {
                        codigo:   codigo,
                        cantidad: parseInt(cantidad),
                    }
                ],
            },
            dataType: 'json',
        })
         .done(function (response) {
             const modal = bootstrap.Modal.getInstance(document.getElementById('modalStorePedido'));
             if (modal && modal._isShown) {
                 modal.hide();
             }

             pNotifySuccess(response.message);

             $('#btn-1-click-loading' + codigo).hide();
             $('#btn-1-click' + codigo).show();

             // Recalculamos los pedidos asignados
             loadPedidosMenu(true);
         })
         .fail(function (jqXHR, status, error) {
             if (jqXHR.status === 422) {
                 errors = composeValidationError(jqXHR.responseJSON.errors);
             } else if (jqXHR.responseJSON.message) {
                 errors = jqXHR.responseJSON.message;
             }
             pNotifyError(errors);
         });

    }
}

/*** /PEDIDO EN UN CLICK ***/

/*** MULTIPEDIDO ***/

window.toggleActionMultiPedido = function (btn) {
    const isHidden   = $('.multipedido-actions').hasClass('d-none');
    const toggleText = isHidden
                       ? `<i class="ri-close-circle-line"></i>${transCancelarMultiseleccion}`
                       : `<i class="ri-checkbox-multiple-line"></i>${transMultiseleccion}`;

    $('.multipedido-actions').toggleClass('d-none', !isHidden);
    $(btn).html(toggleText);

    $('#product-list .product-item').each(function () {
        const container    = $(this).find('.product-item-wrapper .product-info .product-actions .product-sale .product-quantity div');
        const input        = container.find('input');
        const isSelect     = container.find('select').length > 0;
        const currentValue = input.val();

        if (isHidden) {
            // Configuración inicial: poner valores a 0 o "0 - 0" según el tipo de input
            input.val(isSelect ? '0 - 0' : 0);
        } else {
            // Restaurar valores: mantener valores actuales excepto los que están a 0
            if (isSelect && currentValue === '0 - 0') {
                input.val(`1 - ${input.data('unidades')}`);
            } else if (!isSelect && currentValue === '0') {
                input.val(1);
            }
        }

        input.trigger('input');
    });
}

window.asignarCantidades = function () {
    let cantidad = $('#inputAsignacionMultiPedido').val();

    if (!/^\d+$/.test(cantidad) || cantidad < 1) {
        cantidad = cantidad.replace(/\D/g, '');
    }

    $('#product-list .product-item').each(function () {
        let container = $(this).find('.product-item-wrapper .product-info .product-actions .product-sale .product-quantity div');
        if (container.find('select').length > 0) {
            container.find('input').val(`${cantidad} - ${cantidad * container.find('input').data('unidades')}`);
        } else {
            container.find('input').val(cantidad);
        }

        let idArticulo = $(this).find('.product-item-wrapper').attr('id').split('-')[2];
        updateCantidad(container.find('input')[0], idArticulo);
    });
}

window.pedirSeleccionados = async function (button, tipoCarrito) {
    let articulos = {};

    let articulosNoPedibles                    = [];
    let articulosConComunidadAutonomaDiferente = [];
    let articulosConInformacionMinificha       = [];
    let mostrarConfirming                      = false;
    let content                                = '<ul class="text-start">';

    $('#product-list .product-item').each(function () {
        let idArticulo = $(this).find('.product-item-wrapper').attr('id').split('-')[2];
        let cantidad   = $(this).find('.product-item-wrapper .product-info .product-actions .product-sale .product-quantity div input').val();

        if (cantidad.includes(' - ')) {
            cantidad = cantidad.split(' - ')[0];
        }

        if (parseInt(cantidad) > 0) {
            // Si el artículo está descatalogado (código de situación 3) no se añade al carrito
            if ($(this).find('.product-item-wrapper').data('codigo-situacion') === '3') {
                return;
            }

            // Si el artículo no puede ser pedido, se añade a la lista de artículos no pedibles
            if (!$(this).find('.product-item-wrapper').data('puede-ser-pedido')) {
                articulosNoPedibles.push({ean: $(this).find('.product-item-wrapper').data('ean')});
                return;
            }

            // Si el artículo tiene una comunidad autónoma diferente a la del cliente, se añade a la lista de artículos con comunidad diferente
            if ($(this).find('.product-item-wrapper').data('comunidad-diferente')) {
                articulosConComunidadAutonomaDiferente.push({ean: $(this).find('.product-item-wrapper').data('ean')});
            }

            // Si el artículo tiene una comunidad autónoma diferente a la del cliente, se añade a la lista de artículos con comunidad diferente
            if ($(this).find('.product-item-wrapper').data('informacion-minificha')) {
                articulosConInformacionMinificha.push({
                    ean:                  $(this).find('.product-item-wrapper').data('ean'),
                    informacionMinificha: $(this).find('.product-item-wrapper').data('informacion-minificha'),
                });
            }

            let descuento = 0;
            if ($(this).find('.product-item-wrapper .product-info .product-discount-menu').length > 0) {
                $(this).find('.product-item-wrapper .product-info .product-discount-menu li span').each(function () {
                    descuento += parseFloat($(this).text().replace('-', '').replace('%', ''));
                    // Si el artículo es de tipo 'j' o 'p' se tiene que sumar solo el primer descuento
                    if ([
                        'j',
                        'p'
                    ].includes($(this).find('.product-item-wrapper').data('tipo'))) {
                        return false;
                    }
                });
            } else {
                descuento = parseFloat($(this).find('.product-item-wrapper .product-info .product-discount').text().replace('-', '').replace('%', ''));
            }

            articulos[idArticulo] = {
                cantidad:          parseInt(cantidad),
                stock:             $(this).find('.product-item-wrapper').data('stock'),
                precio:            $(this).find('.product-item-wrapper').data('precio'),
                descuentoArticulo: descuento,
                ean:               $(this).find('.product-item-wrapper').data('ean'),
            };

        }
    });
    if (articulosNoPedibles.length > 0) {
        mostrarConfirming = true;
        content += `<p style="margin: 0"><strong>${transAlertaArticulosNoPedibles}</strong></p><ul style="margin: 0">`;
        content += articulosNoPedibles.map(articulo => `<li>${articulo.ean}</li>`).join('');
        content += `</ul>`;
    }
    if (articulosConInformacionMinificha.length > 0) {
        mostrarConfirming = true;
        content += `<p style="margin: 0"><strong>${transArticulosInfoConfirmar}</strong></p><ul style="margin: 0">`;
        content += articulosConInformacionMinificha.map(articulo => `<li>${articulo.ean}: ${articulo.informacionMinificha}</li>`).join('');
        content += `</ul>`;
    }
    if (articulosConComunidadAutonomaDiferente.length > 0) {
        mostrarConfirming = true;
        content += `<p style="margin: 0"><strong>${transArticulosConComunidadDiferente}</strong></p><ul style="margin: 0">`;
        content += articulosConComunidadAutonomaDiferente.map(articulo => `<li>${articulo.ean}</li>`).join('');
        content += `</ul>`;
    }
    if (mostrarConfirming) {
        content += `</ul>`;
        if (!await warningAceptarCancelarConfirming(content)) {
            return false;
        }
    }

    if (Object.keys(articulos).length === 0) {
        pNotifyError(transSeleccionaArticulos);
        return;
    }

    syncArticulosConCarrito(tipoCarrito, articulos, 1, false, button);
}

/*** /MULTIPEDIDO ***/
